<template>
  <div class="problems-select-block" @mouseenter="enablePron" @mouseleave="disablePron">
    <div class="pron" v-if="showPron">
      <span v-for="(p, wordIndex) in pron" style="margin:0 2px">
        <span
          v-for="(s, index) in p"
          :key="index"
          :class="{'target-phoneme': stressed[wordIndex][index]}"
        >{{s.withStress}}</span>
      </span>
    </div>
    <div :class="{ 'hide': showPron}" class="text">{{problem.word}}</div>
    <div class="difficulty">
      <span class="star" v-for="i in problem.difficulty" :key="i">★</span>
    </div>
    <transition name="fade">
      <div
        v-show="!cleared(accessibleScore) &&  accessibleScore!== null"
        class="score"
      >{{Math.ceil(accessibleScore)+'点'}}</div>
    </transition>
    <transition name="fade">
      <div
        v-if="accessibleScore!==null && cleared(accessibleScore) "
        class="score"
      >クリア済 {{Math.ceil(accessibleScore)}}点</div>
    </transition>
    <transition name="fade">
      <div v-show="accessibleScore === null">
        <div class="score">未トライ</div>
      </div>
    </transition>

    <div
      class="progress"
      :style="`width: ${score ? score.score : 0}%`"
      :class="{ 'cleared': cleared(accessibleScore)}"
    ></div>
  </div>
</template>

<script>
import { CLEAR_SCORE } from "@/constants";
import pronDict from "@/utils/PronDictionary";

export default {
  components: {
    // PronConverter: require("@/components/Language/PronConverter").default
  },
  props: ["problem", "targetPhoneme", "score", "selectedLesson"],
  data() {
    return {
      red: true,
      showPron: false,
      activeTraining: false,
      pron: [],
      stressed: [],
      pronLoaded: false
    };
  },
  computed: {
    accessibleScore() {
      if (this.score) {
        return this.score.score;
      } else {
        return null;
      }
    }
  },
  mounted() {},
  destroyed() {
    // this.$bus.off("start-training");
  },

  methods: {
    cleared(score) {
      return score >= CLEAR_SCORE;
    },
    enablePron() {
      let self = this;
      this.showPron = true;
      if (!this.pronLoaded) {
        console.log(this.problem.word);
        pronDict.getIpaFromSingleText(this.problem.word).then(result => {
          const pron = result.map(word => {
            if (word) {
              return word.map(ph => {
                return ph;
              });
            }
          });
          this.pron = pron;

          let targetPhoneme = this.selectedLesson.targetPhoneme;
          const prevPhoneme = this.selectedLesson.titlePhoneme[0];

          console.log(targetPhoneme);
          let stressedArray = [];
          pron.forEach(wordPron => {
            let stressed = [];
            for (let index = 0; index < wordPron.length; index++) {
              if (this.selectedLesson.highlightsPrevious) {
                if (wordPron[index].withoutStress === targetPhoneme) {
                  stressed[index] = true;
                } else {
                  stressed[index] = false;
                }
              } else {
                if (wordPron[index].withoutStress === targetPhoneme) {
                  stressed[index] = true;
                } else {
                  stressed[index] = false;
                }
              }
            }
            console.log(stressed);
            stressedArray.push(stressed);
          });
          self.stressed = stressedArray;
          // console.log(self.stressed);
        });
      }
    },
    disablePron() {
      this.showPron = false;
    }
  }
};
</script>


<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.accented {
  color: #f88 !important;
}
.problems-select-block {
  z-index: 101;
  padding: relative;
  display: inline-block;
  cursor: pointer;
  margin: 15px 20px 0 0;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.05);
  display: inline-block;
  padding: 22px 35px 28px 35px;
  overflow: hidden;
  background-color: #fff;
  transition: 0.3s box-shadow ease;
  font-weight: 600;
  position: relative;
  font-size: 0.7rem;

  @include mq(sm) {
    font-size: 0.8rem;
  }
  @include mq(md) {
    font-size: 0.9rem;
  }
  @include mq(lg) {
    font-size: 1rem;
  }

  &:hover {
    transform: scale(1.04);
    transition: 0.3s box-shadow ease;
    box-shadow: 5px 5px 12px 4px rgba(0, 0, 0, 0.07);
  }

  .difficulty {
    position: absolute;
    right: 8px;
    font-size: 0.3rem;
    top: 0;
    color: rgb(255, 218, 117);
    .star {
      margin-left: 1px;
    }
  }

  .pron {
    display: inline-block;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }

  .hide {
    opacity: 0;
  }
  .progress {
    height: 3px;
    background-color: rgba(0, 64, 128, 0.3);
    width: 0%;
    position: absolute;
    left: 0;
    transition: 0.7s ease;
    bottom: 0;
  }

  .cleared {
    background-color: #f88;
  }

  .score {
    font-size: 10px;
    position: absolute;
    right: 11px;
    bottom: 9px;
    color: rgba(0, 64, 128, 0.3);
    font-weight: 400;
  }

  .text {
    text-align: center;
  }
}

.target-phoneme {
  color: $main-color;
}
</style>
